import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import withStyles from '@mui/styles/withStyles';
import {reduxForm, getFormValues} from 'redux-form';
// import withFormatMessage from '../../../organisms/withFormatMessage.js';
// import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import withRouter from '../../../organisms/withRouter.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
import {FlexGridColumnGroup, FlexGridCellTemplate} from '@grapecity/wijmo.react.grid';
import {sysErr} from '../../../../common/commonGmn.js';
import {renderTextField} from '../../../atoms/CustomPart.js';
import PositiveButton from '../../../atoms/Buttons/PositiveButton.js';
import DangerButton from '../../../atoms/Buttons/DangerButton.js';
import PageTitle from '../../../molecules/PageTitle.js';
// import {
//   Typography,
// } from '@mui/material';

const styles = (theme) => ({
  modal: {
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'none',
  },
  paper: {
    backgroundColor: '#fafafa',
    border: '3px solid #fafafa',
    width: 'auto',
    height: 'auto',
    idth: '95%',
    overflow: 'auto',
    padding: '16pt',
    fontSize: '10pt',
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },

});

// 一覧
const SharedSettingViews = [
  {binding: 'sharedFlag', header: ' ', dataType: 'Boolean', width: 50, isReadOnly: false},
  {binding: 'daihyo', header: '代表', dataType: 'radio', width: 50, isReadOnly: true},
  {binding: 'jyusyo', header: '住所', dataType: 'String', width: 220, isReadOnly: true},
  {binding: 'titenNo', header: '供給地点特定番号', dataType: 'String', width: 190, isReadOnly: true},
  {binding: 'serviceName', header: 'サービスメニュー', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'userName', header: 'お客さま名', dataType: 'String', width: 200, isReadOnly: true},
  {binding: 'blockNo', header: 'ブロック番号', dataType: 'String', width: 100, isReadOnly: true},
  {binding: 'groupNo', header: '共用番号', dataType: 'String', width: 160, isReadOnly: true},
];

class SharedSetting extends React.Component {
  constructor(props) {
    super(props);
    // 一覧Ref作成
    this.gridRef1 = React.createRef();
  }

  closeModal = () => {
    console.log('close');
    this.props.doCloseModal();
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.getInitializeData();
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let SharedSettingList = [];
    // let _dtNo = {...this.state.dtNo};
    let headerData = {dtNo: 'NNNN NNNN NNNN NNNN'};
    SharedSettingList = [
      {sharedFlag: true, daihyo: false, jyusyo: '広島市　ながれまち　NN番地　002', titenNo: '1234567890123456789012', serviceName: '定額電灯', userName: '田中　小学校２', blockNo: '10001', groupNo: 'K0000000001'},
      {sharedFlag: true, daihyo: true, jyusyo: '広島市　ながれまち　NN番地　002', titenNo: '1234567890123456789012', serviceName: '定額電灯', userName: '田中　小学校３', blockNo: '10001', groupNo: 'K0000000001'},
      {sharedFlag: true, daihyo: false, jyusyo: '広島市　ながれまち　NN番地　002', titenNo: '1234567890123456789012', serviceName: '定額電灯', userName: '田中　小学校４', blockNo: '10001', groupNo: 'K0000000001'},
      {sharedFlag: false, daihyo: false, jyusyo: '広島市　ながれまち　NN番地　002', titenNo: '1234567890123456789012', serviceName: '定額電灯', userName: '田中　小学校５', blockNo: '10001', groupNo: ''},
      {sharedFlag: false, daihyo: false, jyusyo: '広島市　ながれまち　NN番地　002', titenNo: '1234567890123456789012', serviceName: '定額電灯', userName: '田中　小学校６', blockNo: '10001', groupNo: ''},
      {sharedFlag: false, daihyo: false, jyusyo: '広島市　ながれまち　NN番地　002', titenNo: '1234567890123456789012', serviceName: '定額電灯', userName: '田中　小学校７', blockNo: '10001', groupNo: ''},
      {sharedFlag: true, daihyo: true, jyusyo: '広島市　ながれまち　NN番地　002', titenNo: '1234567890123456789012', serviceName: '定額電灯', userName: '田中　小学校８', blockNo: '10001', groupNo: 'K0000000002'},
      {sharedFlag: true, daihyo: false, jyusyo: '広島市　ながれまち　NN番地　002', titenNo: '1234567890123456789012', serviceName: '定額電灯', userName: '田中　小学校１', blockNo: '10001', groupNo: 'K0000000002'},
    ];
    // headerData['dtNo']='1234567890123456789012';
    // データを画面に設定
    this.props.doSetInitValues(headerData);
    if (this.gridRef1.current) {
      // 変更前リストデータを画面に設定
      this.gridRef1.current.setItemsSource(SharedSettingList);
    }
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    if (view.dataType === 'radio') {
      return <FlexGridColumnGroup
        binding={view.binding}
        header={view.header}
        dataType='String'
        width={view.width}
        isReadOnly={true}
      >
        <FlexGridCellTemplate cellType="Cell"
          template= {(context) => {
            return <React.Fragment>
              <div style={{textAlign: 'center'}}>
                <input type='radio' name={'radio'+context.item.groupNo} defaultChecked={context.item.daihyo} style={{transform: 'scale(1.3)'}}/>
              </div>
            </React.Fragment>;
          }}>
        </FlexGridCellTemplate>
      </FlexGridColumnGroup>;
    }
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.isReadOnly}/>;
  };

  async componentDidUpdate() {
    try {
      if (this.gridRef1.current && this.state.modaltype ==='Approval') {
        this.getInitializeData();
      } else {
        this.setState({
          modaltype: 'Approval',
        });
      }
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 承認状況描画
   * @return {*}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: true,
      exceptFilters: ['sharedFlag', 'daihyo'],
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      isDisplayCount: true,
      style: {maxHeight: 'auto', maxWidth: '1450px', height: 'auto', width: 'auto', marginTop: 'auto'},
      isReadOnly: false,
      // checkedFunction: this.checkStateUpdate,
    };
    // 一覧定義取得
    let viewElems = [];
    if (SharedSettingViews) {
      for (const view of SharedSettingViews) {
        let viewElem;
        if (view.type === 'Select') {
          break;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef1} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }


  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="dtNo" item xs={12} sm={3}>
            <Field
              id="dtNo"
              name="dtNo"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="電柱番号"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: true,
              }}
            >
            </Field>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {classes, openState, handleClose, handleExec} = this.props;

    return (
      <Modal
        open={openState}
      >
        <PaperPart className={classes.paper}>
          <PageTitle pageTitle={'引込線共用設定'}/>
          <div style={{marginBottom: '20px'}} />
          {this.renderCondition()}
          {/* <div style={{marginBottom: '10px'}} /> */}
          {this.renderTable()}
          <div style={{marginBottom: '10px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="btnCreateComment" item >
              <PositiveButton
                id="btnCreateComment"
                variant="contained"
                size="middium"
                startIcon={<SaveIcon />}
                // onClick={handleExec}
                onClick={handleExec}
              >
                <span>確定</span>
              </PositiveButton>
            </Grid>
            <Grid key="keyDeleteBtn" item>
              <DangerButton
                id="btnDelete"
                variant="contained"
                size="middium"
                startIcon={<DeleteIcon />}
                onClick={this.doDelete}
              >
                <span>削除</span>
              </DangerButton>
            </Grid>
            <Grid key="keyModalCloseBtn" item >
              <NegativeButton
                id="btnCloser"
                variant="contained"
                startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={handleClose}
              >
                <span>閉じる</span>
              </NegativeButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  }
}

SharedSetting.propTypes = {
  classes: PropTypes.object,
  modalInfo: PropTypes.object,
  content: PropTypes.object,
  doCloseModal: PropTypes.func,
  handleClose: PropTypes.func,
  handleExec: PropTypes.func,
  doSetInitValues: PropTypes.func,
  openState: PropTypes.bool,
  dtNo: PropTypes.string.isRequired,
  initialValues: PropTypes.object,
};

const mapStateToProps = (state) => ({
  modalInfo: state.common.modalInfo,
  initialValues: state.common.setInitValues,
});

const mapDispatchToProps = {
  doCloseModal: commonOperations.doCloseModal,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'SharedSetting';

SharedSetting = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(SharedSetting));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(SharedSetting)),
);
